<template>
    <footer class="footer secondary--text font-weight-bold pa-5 px-md-15 py-md-5">
        <div class="footer__container">
            <div class="mb-10 mt-5">
                <v-btn
                    v-for="social in socials"
                    :key="social.name"
                    icon
                    color="secondary"
                    :href="social.url"
                    target="_blank"
                    rel="noopener"
                    :aria-label="social.name">
                    <v-icon>{{ social.icon }}</v-icon>
                </v-btn>
            </div>

            <div class="footer__headings mb-10 text-h5">
                <v-row>
                    <v-col>Address</v-col>
                    <v-col class="d-none d-md-block" />
                    <v-col><div class="text-center text-md-end">Contact</div></v-col>
                </v-row>
            </div>

            <v-row>
                <v-col
                    cols="6"
                    md="4">
                    <v-row class="contact">
                        <v-col
                            cols="12"
                            md="2"
                            class="contact__icon d-flex flex-column justify-center align-start">
                            <v-icon color="secondary">mdi-map-marker</v-icon>
                        </v-col>
                        <v-col
                            cols="12"
                            md="10"
                            class="d-flex flex-column justify-center">
                            <div class="fit-content">
                                <div
                                    v-for="line in contact.address"
                                    :key="line">
                                    {{ line }}
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col
                    cols="6"
                    md="4"
                    class="d-flex flex-column align-center">
                    <v-row class="contact">
                        <v-col
                            cols="12"
                            md="2"
                            class="contact__icon d-flex flex-column justify-center align-start">
                            <v-icon color="secondary">mdi-phone</v-icon>
                        </v-col>
                        <v-col
                            cols="12"
                            md="10"
                            class="d-flex flex-column justify-center">
                            <div class="fit-content">
                                <a
                                    :href="contact.phone.href"
                                    class="text-decoration-none secondary--text">
                                    {{ contact.phone.label }}
                                </a>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col
                    cols="12"
                    md="4"
                    class="d-flex align-center justify-end text-end">
                    <v-icon
                        color="secondary"
                        class="mr-5">
                        mdi-email
                    </v-icon>
                    <a
                        :href="`mailto:${contact.email}`"
                        class="secondary--text">
                        {{ contact.email }}
                    </a>
                </v-col>
            </v-row>

            <div class="my-10 pt-10" />

            <v-row class="align-center text-end mb-5">
                <v-spacer />
                <span class="ml-3">© {{ year }} All Rights Reserved</span>
            </v-row>
        </div>
    </footer>
</template>

<script>
import { contact, socials } from '@/data/profile';

export default {
    name: 'AppFooter',
    data: () => ({
        contact,
        socials,
        year: new Date().getFullYear(),
    }),
};
</script>

<style scoped>
.footer {
    min-height: 400px;
}
.footer__container {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    max-width: 1200px;
    margin: auto;
}
.footer__headings {
    font-family: Arial, sans-serif !important;
}
.fit-content {
    width: fit-content;
}

/* Icon above the text on small screens, beside it from md up. */
.contact {
    align-items: flex-start;
    align-content: flex-start;
}
.contact__icon {
    max-height: 48px;
}
@media (min-width: 960px) {
    .contact {
        align-items: center;
        align-content: normal;
    }
    .contact__icon {
        max-height: none;
    }
}
</style>
